const EnvironmentDetection = {
  isBrowser: typeof window !== 'undefined' && typeof window.document !== 'undefined',
};

/**
 * Globals provided by the webpack definePlugin
 * see:
 *  - webpack.config.js for its implementation
 *  - eslintrc.js to allow our linter to handle globals
 *      -> dont use "ignore unresolved variable" here, add it to eslintrc
 */
const globals = {
  // hash generated by webpack on compile.
  // usually "dev" for dev, and a hash string for prod builds
  bundleHash: global.BUNDLE_HASH,
};

export { globals };
export default EnvironmentDetection;
